import { Routes } from '@angular/router';

import { VANILLA_LAZY_ROUTES, VANILLA_SECONDARY_ROUTES } from '@frontend/loaders/routes';
import { routeData } from '@frontend/vanilla/core';

import { MOKABINGO_ROUTES } from './mokabingo.routes';

export const appRoutes: Routes = [
    {
        path: '',
        loadComponent: () => import('./Home/homelobby/homelobby.component').then((c) => c.HomelobbyComponent),
        data: routeData({ allowAnonymous: true }),
    },
    {
        path: '{culture}',
        children: [
            ...VANILLA_LAZY_ROUTES,
            {
                path: '',
                loadComponent: () => import('./Home/homelobby/homelobby.component').then((c) => c.HomelobbyComponent),
                data: routeData({ allowAnonymous: true }),
            },
            {
                path: 'unifiedgamelaunch/:roomId',
                loadComponent: () => import('./shared/unified-game-launch/unified-game-launch.component').then((c) => c.UnifiedGameLaunchComponent),
                data: routeData({ allowAnonymous: true }),
            },
            {
                path: 'bingo',
                children: [...MOKABINGO_ROUTES],
            },
        ],
    },
    ...VANILLA_SECONDARY_ROUTES,
    {
        path: '**',
        loadChildren: () => import('@frontend/vanilla/features/not-found').then((m) => m.ROUTES),
    },
];
